module.exports = __webpack_public_path__ + "media/4x3/nc-b8c9f5e4.svg";